import React from "react";
import "./../index.css"; // Import the CSS

const mediaLogos = Array.from({ length: 15 }, (_, i) => `https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/partners/${i + 1}.png`);

const MediaMarquee = () => {
  return (
    <div className="marquee-wrapper">
      <div className="marquee-content">
        {mediaLogos.concat(mediaLogos).map((src, index) => (
          <a href="#" key={index}>
            <img src={src} loading="lazy" alt={`Logo ${index + 1}`} />
          </a>
        ))}
      </div>
    </div>
  );
};

export default MediaMarquee;
